import { Reveal } from "./Reveal";
import { Squiggle, VinylRecord, StarDoodle } from "./doodles";

export default function About() {
    return (
        <section id="about" data-testid="about-section" className="bg-cream py-16 sm:py-24">
            <div className="mx-auto max-w-4xl px-4 text-center sm:px-6">
                <Reveal>
                    <div className="relative mx-auto w-fit">
                        <VinylRecord className="mx-auto h-36 w-36 sm:h-44 sm:w-44" />
                        <StarDoodle className="absolute -right-6 top-2 h-6 w-6" fill="#FF70A6" />
                        <StarDoodle className="absolute -left-8 bottom-4 h-5 w-5" fill="#4EDBA2" />
                    </div>
                    <span className="sticker mt-8 bg-mint">07 · The Station</span>
                    <h2 className="mt-4 font-condensed text-3xl font-black uppercase tracking-tight text-ink sm:text-4xl lg:text-5xl">
                        Independent Sound. Real Community.
                    </h2>
                    <Squiggle className="mx-auto mt-3 h-3 w-36" stroke="#4EDBA2" />
                    <p className="mx-auto mt-5 max-w-2xl text-base leading-relaxed text-ink2 sm:text-lg">
                        Inspiration Station is a home for music, creativity, and independent voices.
                        We're building something rooted in good energy, discovery, and giving great
                        sounds a place to be heard.
                    </p>
                    <p className="mt-6 font-hand text-2xl font-bold text-ink2">
                        that's the whole pitch. the rest is music.
                    </p>
                </Reveal>
            </div>
        </section>
    );
}
